import React, {useEffect, useState} from "react";
import request from "../../../Services/API/Requests";
import {Icon, TextField} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Search from "@material-ui/icons/Search";
import {debounce} from "lodash";
import CreateNew from "./CreateNewApplication/CreateNew";
import Layout from "../Layout/Layout";
import {useHistory} from "react-router";

const ApplicationsList = () => {
    const [search, setSearch] = useState();
    const [data, setData] = useState([]);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const history = useHistory();

    useEffect(() => {
        request({
            url: `/dataSource/getData`,
            data: {
                id: "applicationDefaultList",
                pageSize: 25,
                textFilter: search
            }
        }).then(res => {
            setData(res.content)
        }).catch(e => {
            console.log(e)
        })
    }, [search])

    const onChangeSearch = debounce((e) => setSearch(e.target.value), 300);

    return (
        <Layout>
            <div style={{
                padding: 20,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <TextField
                    style={{
                        padding: '10px 0 25px 0'
                    }}
                    placeholder={'search...'}
                    autoFocus={true}
                    onChange={onChangeSearch}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconButton
                                    aria-label="search menu items"
                                >
                                    <Search/>
                                </IconButton>
                            </InputAdornment>)
                    }}
                />
                <div style={{display: "grid", gridTemplateColumns: "auto auto auto auto", gap: 30, maxWidth: 1200}}>
                    <div
                        onClick={() => setIsOpenCreate(true)}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: 150,
                            height: 120,
                            padding: 10,
                        }}>
                        <div style={{
                            padding: 10,
                            backgroundColor: "#dedede",
                            borderRadius: '15%',
                            width: 70,
                            height: 70,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <Icon fontSize={"large"} style={{color: "#3274d0"}}>add</Icon>
                        </div>
                        <Typography style={{padding: 3, paddingTop: 10}} variant={'body2'}>Create New</Typography>
                    </div>
                    {data.length > 0 && (
                        data.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: 'transparent',
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: 150,
                                    height: 120,
                                    padding: 10,
                                }}
                                onClick={() => history.push({pathname: `app-builder/${item.id || item._id}`})}
                            >
                                <div style={{
                                    padding: 10,
                                    backgroundColor: "#bebebe",
                                    borderRadius: '15%',
                                    width: 70,
                                    height: 70,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <Typography variant={"h4"}
                                                style={{color: '#fff'}}>{item.name?.charAt(0).toUpperCase()}</Typography>
                                </div>
                                <Typography variant={'body2'}>{item.name}</Typography>
                            </div>
                        ))
                    )}
                </div>
                <CreateNew
                    isOpen={isOpenCreate}
                    onClose={() => setIsOpenCreate(false)}
                />
            </div>
        </Layout>
    )
}
export default ApplicationsList